import { render, staticRenderFns } from "./LotParkingItem.vue?vue&type=template&id=2c6fae7c&"
import script from "./LotParkingItem.vue?vue&type=script&lang=js&"
export * from "./LotParkingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports